<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          label="CEP"
          v-model="result.cep"
          mask="#####-###"
          @change="getCEP(result.cep)"
          required
        ></v-text-field>
        <v-text-field
          label="Logradouro"
          v-model="result.logradouro"
          ref="rua"
          :counter="100"
          maxlength="100"
        ></v-text-field>
        <v-text-field
          label="Número"
          v-model="result.numero"
          :counter="10"
          maxlength="10"
        ></v-text-field> 
        <v-text-field
          label="Complemento"
          v-model="result.complemento"
          ref="complemento"
        ></v-text-field>
        <v-text-field
          label="Bairro"
          v-model="result.bairro"
          ref="bairro"
        ></v-text-field> 
        <v-text-field
          label="Cidade"
          v-model="result.cidade"
          ref="cidade"
          :counter="50"
          maxlength="50"
        ></v-text-field>
        <v-text-field
          label="Estado"
          v-model="result.estado"
          ref="estado"
          mask="AA"
        ></v-text-field>
        <v-text-field
          label="Telefone"
          v-model="result.telefone"
          mask="(##) #####-####"
        ></v-text-field>
         <v-btn color="primary"  @click.native="$emit('prev')" >voltar</v-btn>
         <v-btn color="primary"  @click.native="proximo" >Continuar</v-btn>
      </v-flex>
    </v-layout>
  </v-form>

</template>

<script>
import api from '@/api'
export default {
  props: [
    'step1Data'
  ],
  data () {
    return {
      groupsOptions: ['Aluno', 'Mediador', 'Admin'],
      genero: ['Feminino', 'Masculino', 'Outro'],
      result: {},
      parente: false,
      options: {},
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail incorreto'
      ],
      valid: true,
      menu2: false
    }
  },
  mounted () {
    let username = this.$store.state.user.username
    api.request('GET', 'user-edit-options/' + username + '/').then((response) => {
      this.options = response.data
    })
    this.$watch('step1Data', function () {
      if (this.step1Data.groups[0] === 'Parente') {
        this.parente = true
      } else {
        this.parente = false
      }
    })
  },
  methods: {
    proximo () {
      if (this.parente) {
        this.$emit('dados2', this.result)
        this.$emit('next2')
      } else {
        this.$emit('dados2', this.result)
        this.$emit('next')
      }
    },
    getCEP (valor) {
      var cep = valor.replace(/\D/g, '')

      var xhr = new XMLHttpRequest();
      var url = 'https://viacep.com.br/ws/' + cep + '/json'
      xhr.open('GET', url, true);
      xhr.responseType = 'json';
      xhr.onload = () => {
        var status = xhr.status;
        if (status === 200) {
          this.$refs.rua.value = xhr.response.logradouro
          this.result.logradouro = xhr.response.logradouro
          this.$refs.cidade.value = xhr.response.localidade
          this.result.cidade = xhr.response.localidade
          this.$refs.bairro.value = xhr.response.bairro
          this.result.bairro = xhr.response.bairro
          this.$refs.estado.value = xhr.response.uf
          this.result.estado = xhr.response.uf
          this.$refs.complemento.value = xhr.response.complemento
          this.result.complemento = xhr.response.complemento
        } else {
          console.log(status)
        }
      };
      xhr.send()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Usuarios/CadastroSteps/Step2.vue